import * as Sentry from "@sentry/react";

/**
 * Sets the Sentry user context to the authenticated user's ID.
 *
 * Only the opaque database ID is sent — no email, name, tokens, or any
 * other personally-identifiable or sensitive information.
 *
 * Call this immediately after a successful login/setUser dispatch.
 */
export function setSentryUser(id: string): void {
  Sentry.setUser({ id });
}

/**
 * Clears the Sentry user context.
 *
 * Call this on logout so that subsequent errors are not attributed to the
 * now-logged-out user and stale identity data is removed from Sentry.
 */
export function clearSentryUser(): void {
  Sentry.setUser(null);
}
